export class MessageStore {
  Id: number;
  ConnectionId: number;
  Name: string;
  Topic: string;
  IsActive: boolean;
  ActiveCount: number;
  DeadLetterCount: number;
}

export enum MessageStoreScope {
  Queue = 1,
  Subscription = 2,
  QueueDeadLetter = 3,
  SubscriptionDeadLetter = 4
}
